module.exports = __webpack_public_path__ + "media/images/manifest/microbius-512-01d5e31ce675237f058e6d5443ad526d.png";